import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'acc-page-header',
    imports: [],
    templateUrl: './page-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './page-header.component.css'
})
export class PageHeaderComponent {

}
